import React from 'react';
import Particles from 'react-particles-js';
import abdulBasir from '../../../images/abdulBasir.png';
import Navbar from '../Navbar';
import './About.css';

const About = () => {
    return (
        <div className = 'bg-dark text-white'>
           <Particles style = {{position: 'absolute'}}
                    params={{
                        particles: {
                        color: {
                            value: "#ffdd40"
                        },
                        line_linked: {
                            color: {
                            value: "#ffdd40"
                            }
                        },
                        number: {
                            value: 60
                        },
                        size: {
                            value: 4
                        }
                        }
                }}
                /> 
            <div className = 'row'>
 
                <div className = 'col-md-6'>
                    <img src={abdulBasir} alt="" className = 'w-100'/>
                </div>
                <div className = 'col-md-6 d-flex justify-content-center align-items-center'>
                    <div>
                        <h2>Hello! I am <span className = 'text-success'>Abdul Basir</span> </h2>
                        <h3 id = 'occupation' className = 'text-primary'>Front End Web Developer <div id="type"></div> </h3>
                    </div>
                </div>
            </div>         
        </div>
    );
};

export default About;